<template>
  <d2-container>
    <template slot="header">
      <el-form
        :inline="true"
        :model="searchForm"
        ref="searchForm"
        size="mini"
        style="margin-bottom: -18px;"
      >


        <el-form-item
                prop="pay_type"
        >
          <el-select
                  class="filter-item"
                  v-model="searchForm.pay_type"
                  placeholder="提现方式"
          >
            <el-option
                    v-for="item in bsOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
        <el-select
                class="filter-item"
                v-model="searchForm.audit_status"
                placeholder="审核是否通过"
                width="50"
        >
          <el-option
                  v-for="item in settleOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
          ></el-option>
        </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
                  v-model="dateRange"
                  :picker-options="pickerOptions"
                  type="daterange"
                  range-separator="~"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"    width="150">

          </el-date-picker>

        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="handleSearchFormSubmit"
          >
            <d2-icon name="search" /> 查询
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button @click="handleSearchFormReset">
            <d2-icon name="refresh" /> 重置
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button
                  type="primary"
                  @click="handleExportFormSubmit"
          >
            <d2-icon name="share" /> 导出
          </el-button>
        </el-form-item>
      </el-form>
    </template>

    <el-table
      :data="tableData"
      v-loading="loading"
      size="small"
      stripe
      highlight-current-row
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
    >

      <el-table-column
        type="selection"
        width="55"
      >
      </el-table-column>
      <el-table-column
              label="提现姓名"
      >
        <template slot-scope="scope">
          {{scope.row.drawname}}
        </template>
      </el-table-column>
      <el-table-column
              label="手机号码"
      >
        <template slot-scope="scope">
          {{scope.row.mobile_no}}
        </template>
      </el-table-column>
      <el-table-column
              label="提现时间"
      >
        <template slot-scope="scope">
          {{scope.row.pay_time2}}
        </template>
      </el-table-column>
      <el-table-column
              label="提现金额"
      >
        <template slot-scope="scope">
          {{scope.row.verifyamt}}
        </template>
      </el-table-column>

      <el-table-column
              label="提现手续费"
      >
        <template slot-scope="scope">
          {{scope.row.serverfee}}
        </template>
      </el-table-column>

      <el-table-column
              label="提现状态"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.state==1">
            提现成功
          </div>
          <div v-else-if="scope.row.state==0 ">
            提现失败：{{scope.row.return_msg}}
          </div>
          <div v-else-if="scope.row.state==3 ">
           提现审核中
          </div>
        </template>
      </el-table-column>

      <el-table-column
              label="提现方式"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.df_type==2">
            微信
          </div>
          <div v-else-if="scope.row.df_type==1">
            支付宝
          </div>


        </template>
      </el-table-column>
      <el-table-column
              label="支付宝账号/微信OPENID"
              :show-overflow-tooltip="true"
              width="250"
      >
        <template slot-scope="scope">
          {{scope.row.bankaccount}}
        </template>
      </el-table-column>
      <el-table-column
              label="平台订单号"
              :show-overflow-tooltip="true"
              width="150"
      >
        <template slot-scope="scope">
          {{scope.row.id}}
        </template>
      </el-table-column>
      <el-table-column
              label="支付宝订单号/微信商户号"
              :show-overflow-tooltip="true"
              width="150"
      >
        <template slot-scope="scope">
          {{scope.row.batch_no}}
        </template>
      </el-table-column>
      <el-table-column
              label="提现来源"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">

          <div v-if="scope.row.oper_type==2">
            小程序钱包提现
          </div>
          <div v-else-if="scope.row.oper_type==1">
            商家APP提现
          </div>
          <div v-else-if="scope.row.oper_type==3">
            拼团补贴提现
          </div>
        </template>
      </el-table-column>


      <el-table-column
        fixed="right"
        label="操作"
        align="center"
        width="220"
      >
        <template slot-scope="scope">

          <el-button
                  type="primary"
                  plain
                  size="mini"
                  v-if="scope.row.state==3"
                  @click="openEditForm(scope.row)"
          >审核</el-button>



        </template>
      </el-table-column>

    </el-table>
    <template slot="footer">
      <el-pagination
        :current-page="page.current"
        :page-size="page.size"
        :total="page.total"
        :page-sizes="[1,10,50,100, 200, 300, 400]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: -10px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </template>
    <edit-form
      :oneclass="oneclass"
      v-model="editFormVisible"
      @submit="getTableData"
    />



  </d2-container>
</template>
<script>
import * as agentService from "@/api/sys/agent";
import editForm from "./editForm";
import util from '@/libs/util.js'
export default {
  name: "SmallposterPage",
  components: { editForm},
  data() {
    const end = new Date();
    const start = new Date();
    return {
      searchForm: {
        pay_type:""
      },
      loading: false,
      tableData: [],
      dateRange: [],
      multipleSelection: [],
      pickerOptions:{},
      bsOptions: [
        {
          value: "1",
          label: "支付宝"
        },
        {
          value: "2",
          label: "微信"
        }
      ],
      settleOptions: [
        {
          value: "0",
          label: "未审核"
        },
        {
          value: "1",
          label: "已审核"
        }
      ],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      sort: {
        prop: "",
        order: ""
      },
        oneclass: {},
      editFormVisible: false
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    getTableData() {
      let query = {
        pageIndex: this.page.current,
        pageSize: this.page.size,
        sortBy: this.sort.prop,
        start_time:this.dateConversion(this.dateRange[0]),
        end_time:this.dateConversion(this.dateRange[1]),
        descending: this.sort.order === "descending",
        filter: this.searchForm
      };
        agentService.getTxOrderPagedlistXq(query).then(data => {
        this.tableData = data.rows;
        this.page.total = data.totalCount;
      });
    },
    handleExportFormSubmit() {
      window.location.href=encodeURI(process.env.VUE_APP_API+"/moblieapp/txUsertoExcel?start_time="+ this.dateConversion(this.dateRange[0])+"&end_time="+this.dateConversion(this.dateRange[1])+"&pay_type="+this.searchForm.pay_type+"&audit_status="+this.searchForm.audit_status);
    },
    dateConversion(value) {
      if (value != null && value != "") {
        var d = new Date(value);
        //  var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
        var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
        console.info("===========date=========" + date);
        return date;
      }else{
        return "";
      }
    },

    handleSearchFormSubmit() {
      this.getTableData();
    },
    handleSearchFormReset() {
      this.$refs.searchForm.resetFields();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSortChange(val) {
      this.sort.prop = val.prop;
      this.sort.order = val.order;
      this.getTableData();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.page.current = val;
      this.getTableData();
    },
    openEditForm(oneclass) {
      this.oneclass = oneclass;
      this.editFormVisible = true;

    }
  }
};
</script>
